import { useState } from 'react';
import Button from '../../../shared/components/Button';
import { Input } from '../../../shared/components/Input';
import { useAttributeReferral } from '../hooks/useReferrals';

/**
 * "Who referred this contact?" — attributes the contact to a referral code (PE-2190). A contact
 * can be attributed once (409 after that); an inactive code or a self-referral is a 400 — the
 * server's message is toasted by ApiFetch either way.
 *
 * osprey-api has no GET for a contact's existing attribution, so this can't show the current
 * referrer; it only records one.
 */
export function ContactReferralPanel({ contactId }: { contactId: string }) {
  const attribute = useAttributeReferral();
  const [code, setCode] = useState('');

  const submit = async () => {
    const trimmed = code.trim();
    if (!trimmed) return;
    await attribute.mutateAsync({ code: trimmed, contactId });
    setCode('');
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 space-y-3">
      <div>
        <h2 className="text-base font-semibold text-foreground">Referral</h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          If someone referred this contact, record their code — the referrer is rewarded when the
          contact signs or first pays.
        </p>
      </div>
      <div className="flex flex-wrap items-end gap-3">
        <Input
          label="Referral code"
          className="w-56 min-h-10 lg:min-h-0"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="ADA-7K3Q"
        />
        <Button
          size="sm"
          className="h-[40px]"
          onClick={submit}
          disabled={!code.trim() || attribute.isPending}
          loading={attribute.isPending}
        >
          Record referral
        </Button>
      </div>
    </div>
  );
}
